export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4837.84f5a019.jpg";